import type { I18nFn } from '#/i18n/types/I18nFn';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { OrgDashboardApiListing } from '#/modules/orgDashboard/api/listing/types/OrgDashboardApiListing';
import type { OrgDashboardApiListingApplicationAdminNotification } from '#/modules/orgDashboard/api/types/OrgDashboardApiListingApplicationAdminNotification';
import type { OrgDashboardApiListingApplicationAttachment } from '#/modules/orgDashboard/api/types/OrgDashboardApiListingApplicationAttachment';
import type { OrgDashboardApiOrg } from '#/modules/orgDashboard/api/types/OrgDashboardApiOrg';
import type { StaffApiListing } from '#/modules/staff/listings/api/types/StaffApiListing';
import type { StaffApiOrg } from '#/modules/staff/listings/orgs/api/types/StaffApiOrg';
// oxlint-disable import/no-namespace
import * as localStorage from '#/utils/localStorage';

export const getDefaultApplyAckText = (
  org: OrgDashboardApiOrg | StaffApiOrg,
  listingType: string,
  listing?: OrgDashboardApiListing | StaffApiListing,
) => {
  const locale: I18nLocale = listing?.locale ?? org.locale;
  let orgName: string;
  if (
    listing &&
    'hasOrgNameOverride' in listing &&
    listing.hasOrgNameOverride &&
    'orgNameOverride' in listing &&
    listing.orgNameOverride
  ) {
    orgName = listing.orgNameOverride;
  } else if (org.name) {
    orgName = org.name;
  } else {
    orgName = '';
  }
  const showOrgName =
    (listing &&
      (listing.type === 'EVENT' || !listing.isPostedAnonymously) &&
      orgName) ??
    false;
  return {
    en: `<p>${listingType === 'VOLOP' ? 'Your application materials' : 'Your resume and application materials'} have been successfully submitted ${
      showOrgName ? `to ${orgName} ` : ''
    }for the listing below.</p><p>Best Regards,</p><p>${
      showOrgName ? `${orgName}` : 'The Idealist Community Support Team'
    }</p>`,
    es: `<p>${listingType === 'VOLOP' ? 'Tu materiales' : 'Tu currículum y otros materiales'} para tu postulación se han enviado correctamente ${
      showOrgName ? `a ${orgName} ` : ''
    }para esta oportunidad.</p><p>Suerte,</p><p>${
      showOrgName ? `${orgName}` : 'El Equipo de Idealist en Español'
    }</p>`,
    pt: `<p>${listingType === 'VOLOP' ? 'O material de inscrição foi submetido' : 'O seu currículo e material de inscrição foram submetidos'} com sucesso ${
      showOrgName ? `para ${orgName} ` : ''
    }para o anúncio abaixo.</p><p>Saudações,</p><p>${
      showOrgName ? `${orgName}` : 'Equipe de Suporte à Comunidade Idealista'
    }</p>`,
  }[locale];
};
const HAS_USED_ATS = 'hasUsedAts';
export const usedAts = () => localStorage.setItem(HAS_USED_ATS, true);
export const hasUsedAts = () => localStorage.getItem(HAS_USED_ATS);

export function getMostRecentAdminNotification(
  adminNotifications?: OrgDashboardApiListingApplicationAdminNotification[],
) {
  if (!Array.isArray(adminNotifications)) {
    return null;
  }

  return adminNotifications[adminNotifications.length - 1];
}

export function formatApplicantQuestionResponse(
  i18n: I18nFn,
  question: OrgDashboardApiListingApplicationAttachment,
) {
  switch (question.type) {
    case 'TEXT':
      return question.text;
    case 'OPTION_MANY':
      return question.options.join('\n');
    case 'OPTION_SINGLE':
      return question.option;
    case 'ACKNOWLEDGEMENT':
      return question.acknowledged ? i18n('Yes') : i18n('No');
    case 'FILE':
      return '';
    case 'URL':
      return '';
    case 'PHONE':
      return '';
  }
}
